<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs12, sm12, md10, lg9, text-xs-center)
          .review(v-if='sent', color='primary', @click.prevent='')
          v-card(flat)
            breadcrumb(back='page1-4')
              | Estás en: Elige tu Crédito Hipotecario / ¿Estoy listo para cursar esta lección?
            v-card-text.label16tt.withDivider
              span(style='color:#F7893B') PREGUNTA 4 DE 5
            v-card-text.titulo24Reg.text-center
              | Conocer aspectos relacionados al Costo Anual Total (CAT), ayuda a tomar una mejor decisión al adquirir cualquier tipo de crédito, ¿qué conoces al respecto?
            v-card-text.parrafoDestacadoB.text-center  Marque la respuesta correcta.
            v-card.questionCard(justify-center, flat)
              v-card-text.titulo18Book.text-center
                | De las opciones señaladas, selecciona aquellas que se asocian verdaderamente al Costo Anual Total (CAT)
              v-layout.ml-5.my-0.py-0(v-for='(reactivo, index) in reactivos', :key='index')
                v-flex(xs1, offset-xs1, align-center, align-content-center)
                  v-icon(size='15px', color='green', v-if='sent && (reactivo.resultado === 1)') fas fa-check
                  v-icon(size='15px', color='red', v-if='sent && (reactivo.resultado === 0)') fas fa-times
                v-flex(xs1)
                  v-checkbox(style="margin-top: -7px;", hide-details, v-model='reactivo.respuesta')
                v-flex.parrafoDestacadoB.text-xs-left.py-2(xs10, align-content-center)
                  | {{reactivo.descripcion}}
              v-spacer.pb-4
            v-layout(row, justify-center)
              v-flex
                div(v-if=' sent==false ')
                  v-btn.btn(color='secondary ', v-bind:class='responseIsNone ', @click='sendResult() ')
                    | Enviar
                div(v-if='sent ')
                  v-btn.btn(color='accent ', style='z-index:2', @click.prevent='dialog=true ')
                    | Ver Retroalimentación
                  v-dialog(v-model='dialog ', persistent, max-width='930px ')
                    v-layout(row, justify-center)
                      v-flex(text-xs-center)
                        v-card
                          .pt-1.pr-2(v-if='sent && (response==1) ')
                            v-layout(row, justify-center)
                              v-flex(text-xs-center)
                                img.dialog_img(src='assets/Leccion_1.5_ManoArriba.png ')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | ¡Bien!
                            v-card.questionCard(flat)
                              v-card-text.dialog_text
                                p.text-sm-left.px-5.my-0
                                  | Efectivamente, hay dos tipos de CAT (real y publicitario); el CAT de tu crédito disminuirá con una buena administración y por lo tanto el CAT puede variar mensualmente.
                                p.text-sm-left.px-5.my-0
                                  | Es importante que conozcas el CAT de cada uno de tus créditos y todos los elementos que influyen para determinarlo. Puedes consultarlo en tu contrato, y cada mes ver su variación dependiendo tus tipos de crédito y la administración
                                  | que tengas de los mismos.
                                p.text-sm-left.px-5 
                                  | Si quieres saber más sobre el concepto de CAT, 
                                  a(href="https://www.bancomer.com/personas/educacion-financiera/que-es-el-cat-en-mi-tarjeta-de-credito.html" target="_blank") consulta este enlace 
                          .pt-1.pr-2(v-if='sent && (response!=1) ')
                            v-layout(row, justify-center)
                              v-flex(text-xs-center)
                                img.dialog_img(src='assets/Leccion_1.5_ManoStop.png ')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | Hay una mejor respuesta...
                            v-card.questionCard(flat)
                              v-card-text.dialog_text
                                p.text-sm-left.px-5.my-0
                                  b
                                    | El CAT es uno de los elementos importantes a tomar en cuenta cuando eliges un crédito.
                                p.text-sm-left.px-5.my-0
                                  | Existen dos tipos de CAT. El publicitario, que es un número promedio que se muestra en la comunicación de los bancos, y el segundo que es el CAT real. Este CAT real es el que corresponde a tu situación específica al contratar.
                                  | El CAT no es fijo, variará dependiendo de la buena administración que tengas de tu crédito.
                                p.text-sm-left.px-5.my-0
                                  | Es importante que conozcas el CAT de cada uno de tus créditos y todos los elementos que influyen para determinarlo. Puedes consultarlo en tu contrato, y cada mes ver su variación dependiendo tus tipos de crédito y la administración
                                  | que tengas de los mismos.
                                p.text-sm-left.px-5 
                                  | Si quieres saber más sobre el concepto de CAT, 
                                  a(href="https://www.bancomer.com/personas/educacion-financiera/que-es-el-cat-en-mi-tarjeta-de-credito.html" target="_blank") consulta este enlace 
                          v-btn.btn.dialog_btn(color='accent ', @click.prevent="nextPage( 'page1-6') ")
                            | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>

<script>
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  data() {
    return {
      reactivos: [{
          descripcion: 'EXISTEN DOS TIPOS DE CAT, EL REAL Y EL PUBLICITARIO.',
          correcta: true,
          respuesta: false,
          resultado: 0
        },
        {
          descripcion: 'ENTRE MEJOR MANEJO DE TU CRÉDITO TENGAS, ESTE PORCENTAJE CAT DISMINUIRÁ.',
          correcta: true,
          respuesta: false,
          resultado: 0
        },
        {
          descripcion: 'PUEDE VARIAR MENSUALMENTE, DEPENDIENDO DE LOS MONTOS QUE CUBRAS EN TU FECHA DE PAGO.',
          correcta: true,
          respuesta: false,
          resultado: 0
        },
        {
          descripcion: 'SÓLO HAY UN TIPO DE CAT.',
          correcta: false,
          respuesta: false,
          resultado: 0
        },
        {
          descripcion: 'EL CAT ES FIJO, NO SE PUEDE DISMINUIR.',
          correcta: false,
          respuesta: false,
          resultado: 0
        },
      ],
      selected: [],
      resultado: 0,
      response: 'none',
      sent: false,
      feedback: false,
      dialog: false
    }
  },
  methods: {
    grade: function() {
      var points = 0;
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.correcta == reactivo.respuesta) {
          reactivo.resultado = 1;
          points++;
        }
      });
      this.resultado = points / this.reactivos.length;
    },
    sendResult() {
      this.grade();
      this.sent = true;
      eventBus.$emit('send_result', this.resultado);
      eventBus.$emit('suspend_data', this.reactivos);
      this.response = this.resultado;
    },
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    },
    lastPage(page) {
      this.progress = true;
      eventBus.$emit('last_page', page);
    }
  },
  created() {
    if ('suspend_data'in this.$parent) {
      if (this.$parent.currentPage in this.$parent.suspend_data) {
        this.reactivos = this.$parent.suspend_data[this.$parent.currentPage];
        this.sendResult();
      }
    }
  },
  computed: {
    checkResult() {
      return {
        'done': this.response != 'none',
        'clear': this.response == 'none'
      }
    }
  }
};
</script>
